<template>
  <div>
    <Layout>
      <div class="container">
        <div class="cardInformation">
          <Card
           title="Relatórios"
            subtitle="Aprovados"
            :qtd="aprovados"
            @some-event="clickGreen"
            :class="{ cardGreen }"
          />

          <Card
          title="Relatórios"
          subtitle="Reprovados"
            :qtd="reprovados"
            @some-event="clickRed"
            :class="{ cardRed }"
          />

          <Card
            v-if="role == 'eng_analista' || role == 'eng_admin'"
           title="Relatórios em"
            subtitle="Homologação"
            :qtd="revisao"
            @some-event="clickBlue"
            :class="{ cardBlue }"
          />

          

        </div>
        <ModalRRIM :role="role" />
        <div class="main">
          <div class="tableRRIM" v-if="cardGreen">
            <h3>Relatórios aprovados</h3>
            <TableRRIM :role="role" />
          </div>
          <div class="tableRRIM" v-if="cardRed">
            <h3>Relatórios reprovados</h3>
            <TableReprovada :role="role" />
          </div>
          <div class="tableRRIM" v-if="cardBlue">
            <h3>Relatórios em homologação</h3>
            <TableRevisao />
          </div>
        </div>
        <div class="footer"></div>
      </div>
    </Layout>
  </div>
</template>

<script>
import ModalRRIM from "../../components/Modais/ModalRRIM/ModalRRIM.vue";
import Layout from "../Layout/Layout.vue";
import ButtonAdd from "../../components/Button/Button_M1.vue";
// import TableRRIM from "../../components/Tables/TableRRIM.vue";;
import TableRRIM from "../Test/Table.vue";
import TableRevisao from "../Test/TableRevisao.vue";
import TableReprovada from "../Test/TableReprovado.vue";
import Card from "../../components/Cards/Card.vue";
import { GetAllCount } from "../../controllers/RRIM/GetCountRRIMs";

export default {
  components: {
    Layout,
    ButtonAdd,
    TableRRIM,
    ModalRRIM,
    Card,
    TableRevisao,
    TableReprovada,
  },
  async created() {
    // this.$store.commit("SetLoadingPattern", true); // Insere o loading
    this.role = this.$store.state.user.nivel_de_acesso.descricao;
    const count = await GetAllCount();
    this.revisao = count.revisao;
    this.aprovados = count.aprovados;
    this.reprovados = count.reprovados;
    // this.$store.commit("SetLoadingPattern", false); // Tira o loading
  },
  data() {
    return {
      role: null,
      table: true,
      vmodal: false,
      cardGreen: true,
      cardRed: false,
      cardBlue: false,
      revisao: 0,
      aprovados: 0,
      reprovados: 0,
      modificacao: 0
    };
  },
  name: "HomeComponenet",
  methods: {
    click_vmodal() {
      this.vmodal = !this.vmodal;
      const modalOpen = document.getElementById("modalOpen");
      modalOpen.classList.add("modal-open");
    },
    clickGreen() {
      this.table = false;
      this.cardGreen = true;
      this.cardRed = false;
      this.cardBlue = false;
    },
    clickRed() {
      this.table = false;
      this.cardRed = true;
      this.cardGreen = false;
      this.cardBlue = false;
    },
    clickBlue() {
      this.table = false;
      this.cardBlue = true;
      this.cardRed = false;
      this.cardGreen = false;
    },
    clickMolde() {
      this.table = false;
      this.cardBlue = false;
      this.cardRed = false;
      this.cardGreen = false;
    }
  },
};
</script>

<style scoped>

.sc1 {
  overflow-y: hidden;
}
.header h2 {
  font-size: 1.5vw;
}
.container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.container .cardInformation {
  width: 100%;
  height: 7rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 6vh 0 2rem;
  overflow-x: auto;
}

.cardGreen {
  border: 0.1rem solid var(--green);
}

.cardRed {
  border: 0.1rem solid var(--red);
}

.cardBlue {
  border: 0.1rem solid var(--blue);
}

.tableRRIM {
  width: 100%;
  /* padding: 1rem; */
  /* background: var(--white); */
  border-radius: 1rem;
  /* overflow: auto; */
}


@media (max-width: 692px) {
  .header h2 {
    font-size: 3.5vw;
  }

  .main {
    width: 100%;
    height: 100%;
    margin-left: 0px;
    padding: 20px;
    transition: 0.5s;
  }
}

@media (max-width: 425px) {
  .container .cardInformation {
    height: auto;
    margin: 0;
    padding: 1rem;
    flex-wrap: wrap;
  }
}

@media (max-width: 320px) {
  .container .cardInformation {
    flex-direction: column;
  }
}
</style>
